import * as R from "ramda";
import { format } from "d3-format";
import { PERCENT, CURRENCY, NUMBER, TEXT, RATE } from "./datacenterData.js";

// https://github.com/d3/d3-format#locale_formatPrefix
// convert from SI prefix abbreviations to standard
const siToIllions = R.compose(
  R.replace("k", "k"), // thousands
  R.replace("M", "m"), // millions
  R.replace("G", "b"), // billions
  R.replace("T", "t"), // trillions
);

export function dataTypeFormatter(dataType) {
  const defaultNonNumbers = (fn) => R.ifElse(Number.isFinite, fn, () => "-");

  // format(",~s")(0.5) is returning 500m instead of 0.5 🤔
  // we need to hack around that...
  const isZeroToOne = (d) => d > 0 && d < 1;

  switch (dataType) {
    case PERCENT: {
      return defaultNonNumbers(format(",~%"));
    }

    case CURRENCY: {
      const formatter = R.compose(
        siToIllions,
        R.ifElse(isZeroToOne, format("$.2f"), format("$,.2~s")),
      );
      return defaultNonNumbers(formatter);
    }

    case NUMBER: {
      const formatter = R.compose(siToIllions, format(",~s"));
      return R.compose(defaultNonNumbers, R.unless(isZeroToOne))(formatter);
    }

    case RATE: {
      return defaultNonNumbers((d) => d);
    }

    case TEXT:
    default:
      return (d) => d;
  }
}
